// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Generator.css - 生成器组件样式 */

/* ===== 生成区域容器 ===== */
.gen-container {
  width: 92%;
  max-width: 1050px;
  background: var(--card-bg);
  border: 1px solid rgba(0, 229, 255, 0.2);
  border-radius: 24px;
  padding: 30px;
  backdrop-filter: blur(25px);
  box-shadow:
    0 30px 60px rgba(0, 0, 0, 0.6),
    inset 0 0 20px rgba(0, 229, 255, 0.05);
}

.gen-layout {
  display: flex;
  gap: 20px;
}

/* ===== 上传区域 ===== */
.upload-area {
  width: 150px;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-size: 0.85rem;
  color: var(--text-dim);
  transition: 0.3s;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(0, 229, 255, 0.1);
}

.upload-area:hover {
  background: rgba(0, 229, 255, 0.12);
  color: #fff;
  border-color: rgba(0, 229, 255, 0.3);
  transform: translateY(-2px);
}

.upload-area i {
  font-size: 28px;
  color: var(--primary);
  margin-bottom: 10px;
  text-shadow: 0 0 10px rgba(0, 229, 255, 0.5);
}

/* ===== 输入区域 ===== */
.input-area {
  flex-grow: 1;
  position: relative;
}

.input-area textarea {
  width: 100%;
  height: 120px;
  background: rgba(0, 0, 0, 0.35);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 16px;
  padding: 20px;
  color: #fff;
  resize: none;
  outline: none;
  font-size: 1rem;
  transition: 0.3s;
  line-height: 1.6;
  font-family: 'Exo 2', sans-serif;
}

.input-area textarea:focus {
  background: rgba(0, 0, 0, 0.5);
  border-color: var(--primary);
  box-shadow:
    0 0 15px rgba(0, 229, 255, 0.1),
    inset 0 0 10px rgba(0, 229, 255, 0.05);
}

.input-area textarea::placeholder {
  color: #5a6a85;
}

/* ===== 时长选择器 ===== */
.duration-dropdown {
  position: absolute;
  right: 15px;
  bottom: 15px;
  z-index: 100;
  font-family: 'Orbitron';
}

.duration-trigger {
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: rgba(0, 229, 255, 0.7);
  padding: 6px 14px;
  border-radius: 10px;
  font-size: 0.7rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  transition: all 0.4s ease;
  backdrop-filter: blur(8px);
}

.duration-trigger:hover {
  background: rgba(0, 229, 255, 0.08);
  border-color: rgba(0, 229, 255, 0.4);
  color: var(--primary);
  box-shadow: 0 0 15px rgba(0, 229, 255, 0.1);
}

.duration-trigger i {
  font-size: 0.55rem;
  opacity: 0.6;
  transition: 0.3s;
}

.duration-list {
  position: absolute;
  bottom: 110%;
  right: 0;
  background: rgba(10, 15, 28, 0.95);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  overflow: hidden;
  display: none;
  flex-direction: column;
  width: 85px;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.8);
  backdrop-filter: blur(20px);
}

.duration-list.show {
  display: flex;
  animation: fadeInUp 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}

@keyframes fadeInUp {
  from { opacity: 0; transform: translateY(15px) scale(0.95); }
  to { opacity: 1; transform: translateY(0) scale(1); }
}

.duration-item {
  padding: 12px;
  text-align: center;
  color: var(--text-dim);
  font-size: 0.75rem;
  cursor: pointer;
  transition: 0.3s;
  border-bottom: 1px solid rgba(255, 255, 255, 0.03);
}

.duration-item:last-child {
  border-bottom: none;
}

.duration-item {
  padding: 12px 16px;
  text-align: center;
}

.duration-item:hover {
  background: rgba(0, 229, 255, 0.1);
  color: var(--primary);
}

.duration-item.active {
  color: var(--primary);
  font-weight: bold;
  background: rgba(0, 229, 255, 0.05);
}

/* ===== 按钮区域 ===== */
.btn-area {
  width: 160px;
}

.gen-btn {
  width: 100%;
  height: 100%;
  border: none;
  border-radius: 16px;
  background: linear-gradient(135deg, #0072ff, var(--primary));
  color: white;
  font-weight: 700;
  cursor: pointer;
  transition: 0.4s;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  font-family: 'Orbitron';
  position: relative;
  overflow: hidden;
}

.gen-btn:hover {
  box-shadow: 0 0 30px rgba(0, 229, 255, 0.5);
  transform: translateY(-3px);
}

.gen-btn i {
  font-size: 24px;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% { opacity: 1; }
  50% { opacity: 0.6; }
  100% { opacity: 1; }
}

/* ===== 标签行 ===== */
.tag-row {
  display: flex;
  gap: 12px;
  margin-top: 20px;
  align-items: center;
  flex-wrap: wrap;
}

.tag-row span {
  font-size: 0.9rem;
  color: #718096;
  font-weight: 600;
}

.tag {
  padding: 6px 16px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  font-size: 0.8rem;
  cursor: pointer;
  transition: 0.3s;
  color: var(--text-dim);
  border: 1px solid transparent;
}

.tag:hover {
  background: rgba(0, 229, 255, 0.15);
  color: var(--primary);
  border-color: var(--primary);
}

/* 响应式设计 */
@media (max-width: 768px) {
  .gen-container {
    width: 95%;
    padding: 20px;
  }

  .gen-layout {
    flex-direction: column;
  }

  .upload-area {
    width: 100%;
    height: 80px;
    flex-direction: row;
    gap: 10px;
  }

  .btn-area {
    width: 100%;
    height: 60px;
  }

  .gen-btn {
    flex-direction: row;
  }
}

@media (max-width: 480px) {
  .gen-container {
    width: 98%;
    padding: 15px;
  }

  .tag-row {
    gap: 8px;
  }

  .tag {
    padding: 4px 12px;
    font-size: 0.75rem;
  }
}

/* ===== 新增样式 ===== */

/* 错误消息 */
.error-message {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  background: rgba(255, 68, 68, 0.1);
  border: 1px solid rgba(255, 68, 68, 0.3);
  border-radius: 8px;
  margin-bottom: 16px;
  color: #ff6b6b;
}

.error-message i {
  font-size: 1.1rem;
}

.error-message span {
  flex: 1 1;
  font-size: 0.9rem;
}

.close-error {
  background: transparent;
  border: none;
  color: #ff6b6b;
  cursor: pointer;
  padding: 4px;
}

.close-error:hover {
  color: #ff4444;
}

/* 图片预览 */
.upload-area.has-image {
  padding: 0;
  overflow: hidden;
  border: 2px solid rgba(0, 240, 255, 0.4);
}

.image-preview {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* 标题输入 */
.title-input {
  width: 100%;
  padding: 12px;
  margin-bottom: 12px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  color: #fff;
  font-size: 0.95rem;
  outline: none;
  transition: border 0.3s;
}

.title-input:focus {
  border-color: rgba(0, 240, 255, 0.3);
}

.title-input::placeholder {
  color: #666;
}

/* 积分提醒 */
.points-reminder {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  background: rgba(255, 215, 0, 0.08);
  border-radius: 6px;
  margin-top: 12px;
  font-size: 0.85rem;
  color: #ffd700;
}

.points-reminder i {
  font-size: 0.9rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/Generator.css"],"names":[],"mappings":"AAAA,4BAA4B;;AAE5B,uBAAuB;AACvB;EACE,UAAU;EACV,iBAAiB;EACjB,0BAA0B;EAC1B,wCAAwC;EACxC,mBAAmB;EACnB,aAAa;EACb,2BAA2B;EAC3B;;0CAEwC;AAC1C;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA,qBAAqB;AACrB;EACE,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,qCAAqC;EACrC,wCAAwC;AAC1C;;AAEA;EACE,mCAAmC;EACnC,WAAW;EACX,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA,qBAAqB;AACrB;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,+BAA+B;EAC/B,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B;;0CAEwC;AAC1C;;AAEA;EACE,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,6BAA6B;EAC7B,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;EACpC,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,kCAAkC;EAClC,2CAA2C;EAC3C,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sDAAsD;AACxD;;AAEA;EACE,OAAO,UAAU,EAAE,uCAAuC,EAAE;EAC5D,KAAK,UAAU,EAAE,iCAAiC,EAAE;AACtD;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kDAAkD;AACpD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA,qBAAqB;AACrB;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,4DAA4D;EAC5D,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,2CAA2C;EAC3C,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,KAAK,UAAU,EAAE;EACjB,MAAM,YAAY,EAAE;EACpB,OAAO,UAAU,EAAE;AACrB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,mCAAmC;EACnC,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA,UAAU;AACV;EACE;IACE,UAAU;IACV,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,UAAU;IACV,aAAa;EACf;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAEA,qBAAqB;;AAErB,SAAS;AACT;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kCAAkC;EAClC,wCAAwC;EACxC,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA,SAAS;AACT;EACE,UAAU;EACV,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA,SAAS;AACT;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,0CAA0C;EAC1C,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,WAAW;AACb;;AAEA,SAAS;AACT;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":["/* Generator.css - 生成器组件样式 */\n\n/* ===== 生成区域容器 ===== */\n.gen-container {\n  width: 92%;\n  max-width: 1050px;\n  background: var(--card-bg);\n  border: 1px solid rgba(0, 229, 255, 0.2);\n  border-radius: 24px;\n  padding: 30px;\n  backdrop-filter: blur(25px);\n  box-shadow:\n    0 30px 60px rgba(0, 0, 0, 0.6),\n    inset 0 0 20px rgba(0, 229, 255, 0.05);\n}\n\n.gen-layout {\n  display: flex;\n  gap: 20px;\n}\n\n/* ===== 上传区域 ===== */\n.upload-area {\n  width: 150px;\n  border-radius: 16px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  font-size: 0.85rem;\n  color: var(--text-dim);\n  transition: 0.3s;\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(0, 229, 255, 0.1);\n}\n\n.upload-area:hover {\n  background: rgba(0, 229, 255, 0.12);\n  color: #fff;\n  border-color: rgba(0, 229, 255, 0.3);\n  transform: translateY(-2px);\n}\n\n.upload-area i {\n  font-size: 28px;\n  color: var(--primary);\n  margin-bottom: 10px;\n  text-shadow: 0 0 10px rgba(0, 229, 255, 0.5);\n}\n\n/* ===== 输入区域 ===== */\n.input-area {\n  flex-grow: 1;\n  position: relative;\n}\n\n.input-area textarea {\n  width: 100%;\n  height: 120px;\n  background: rgba(0, 0, 0, 0.35);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 16px;\n  padding: 20px;\n  color: #fff;\n  resize: none;\n  outline: none;\n  font-size: 1rem;\n  transition: 0.3s;\n  line-height: 1.6;\n  font-family: 'Exo 2', sans-serif;\n}\n\n.input-area textarea:focus {\n  background: rgba(0, 0, 0, 0.5);\n  border-color: var(--primary);\n  box-shadow:\n    0 0 15px rgba(0, 229, 255, 0.1),\n    inset 0 0 10px rgba(0, 229, 255, 0.05);\n}\n\n.input-area textarea::placeholder {\n  color: #5a6a85;\n}\n\n/* ===== 时长选择器 ===== */\n.duration-dropdown {\n  position: absolute;\n  right: 15px;\n  bottom: 15px;\n  z-index: 100;\n  font-family: 'Orbitron';\n}\n\n.duration-trigger {\n  background: rgba(255, 255, 255, 0.03);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  color: rgba(0, 229, 255, 0.7);\n  padding: 6px 14px;\n  border-radius: 10px;\n  font-size: 0.7rem;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  transition: all 0.4s ease;\n  backdrop-filter: blur(8px);\n}\n\n.duration-trigger:hover {\n  background: rgba(0, 229, 255, 0.08);\n  border-color: rgba(0, 229, 255, 0.4);\n  color: var(--primary);\n  box-shadow: 0 0 15px rgba(0, 229, 255, 0.1);\n}\n\n.duration-trigger i {\n  font-size: 0.55rem;\n  opacity: 0.6;\n  transition: 0.3s;\n}\n\n.duration-list {\n  position: absolute;\n  bottom: 110%;\n  right: 0;\n  background: rgba(10, 15, 28, 0.95);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 12px;\n  overflow: hidden;\n  display: none;\n  flex-direction: column;\n  width: 85px;\n  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.8);\n  backdrop-filter: blur(20px);\n}\n\n.duration-list.show {\n  display: flex;\n  animation: fadeInUp 0.3s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n@keyframes fadeInUp {\n  from { opacity: 0; transform: translateY(15px) scale(0.95); }\n  to { opacity: 1; transform: translateY(0) scale(1); }\n}\n\n.duration-item {\n  padding: 12px;\n  text-align: center;\n  color: var(--text-dim);\n  font-size: 0.75rem;\n  cursor: pointer;\n  transition: 0.3s;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.03);\n}\n\n.duration-item:last-child {\n  border-bottom: none;\n}\n\n.duration-item {\n  padding: 12px 16px;\n  text-align: center;\n}\n\n.duration-item:hover {\n  background: rgba(0, 229, 255, 0.1);\n  color: var(--primary);\n}\n\n.duration-item.active {\n  color: var(--primary);\n  font-weight: bold;\n  background: rgba(0, 229, 255, 0.05);\n}\n\n/* ===== 按钮区域 ===== */\n.btn-area {\n  width: 160px;\n}\n\n.gen-btn {\n  width: 100%;\n  height: 100%;\n  border: none;\n  border-radius: 16px;\n  background: linear-gradient(135deg, #0072ff, var(--primary));\n  color: white;\n  font-weight: 700;\n  cursor: pointer;\n  transition: 0.4s;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  font-family: 'Orbitron';\n  position: relative;\n  overflow: hidden;\n}\n\n.gen-btn:hover {\n  box-shadow: 0 0 30px rgba(0, 229, 255, 0.5);\n  transform: translateY(-3px);\n}\n\n.gen-btn i {\n  font-size: 24px;\n  animation: pulse 2s infinite;\n}\n\n@keyframes pulse {\n  0% { opacity: 1; }\n  50% { opacity: 0.6; }\n  100% { opacity: 1; }\n}\n\n/* ===== 标签行 ===== */\n.tag-row {\n  display: flex;\n  gap: 12px;\n  margin-top: 20px;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.tag-row span {\n  font-size: 0.9rem;\n  color: #718096;\n  font-weight: 600;\n}\n\n.tag {\n  padding: 6px 16px;\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 8px;\n  font-size: 0.8rem;\n  cursor: pointer;\n  transition: 0.3s;\n  color: var(--text-dim);\n  border: 1px solid transparent;\n}\n\n.tag:hover {\n  background: rgba(0, 229, 255, 0.15);\n  color: var(--primary);\n  border-color: var(--primary);\n}\n\n/* 响应式设计 */\n@media (max-width: 768px) {\n  .gen-container {\n    width: 95%;\n    padding: 20px;\n  }\n\n  .gen-layout {\n    flex-direction: column;\n  }\n\n  .upload-area {\n    width: 100%;\n    height: 80px;\n    flex-direction: row;\n    gap: 10px;\n  }\n\n  .btn-area {\n    width: 100%;\n    height: 60px;\n  }\n\n  .gen-btn {\n    flex-direction: row;\n  }\n}\n\n@media (max-width: 480px) {\n  .gen-container {\n    width: 98%;\n    padding: 15px;\n  }\n\n  .tag-row {\n    gap: 8px;\n  }\n\n  .tag {\n    padding: 4px 12px;\n    font-size: 0.75rem;\n  }\n}\n\n/* ===== 新增样式 ===== */\n\n/* 错误消息 */\n.error-message {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 16px;\n  background: rgba(255, 68, 68, 0.1);\n  border: 1px solid rgba(255, 68, 68, 0.3);\n  border-radius: 8px;\n  margin-bottom: 16px;\n  color: #ff6b6b;\n}\n\n.error-message i {\n  font-size: 1.1rem;\n}\n\n.error-message span {\n  flex: 1;\n  font-size: 0.9rem;\n}\n\n.close-error {\n  background: transparent;\n  border: none;\n  color: #ff6b6b;\n  cursor: pointer;\n  padding: 4px;\n}\n\n.close-error:hover {\n  color: #ff4444;\n}\n\n/* 图片预览 */\n.upload-area.has-image {\n  padding: 0;\n  overflow: hidden;\n  border: 2px solid rgba(0, 240, 255, 0.4);\n}\n\n.image-preview {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n/* 标题输入 */\n.title-input {\n  width: 100%;\n  padding: 12px;\n  margin-bottom: 12px;\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 8px;\n  color: #fff;\n  font-size: 0.95rem;\n  outline: none;\n  transition: border 0.3s;\n}\n\n.title-input:focus {\n  border-color: rgba(0, 240, 255, 0.3);\n}\n\n.title-input::placeholder {\n  color: #666;\n}\n\n/* 积分提醒 */\n.points-reminder {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 12px;\n  background: rgba(255, 215, 0, 0.08);\n  border-radius: 6px;\n  margin-top: 12px;\n  font-size: 0.85rem;\n  color: #ffd700;\n}\n\n.points-reminder i {\n  font-size: 0.9rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
